import "@preline/accordion";

/**
 * Initializes all Preline “accordion” components once the DOM is ready.
 * @returns {void}
 */
const init = () => {
  window.HSStaticMethods?.autoInit?.(["accordion"]);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init, { once: true });
} else {
  init();
}